const palette = {
    'primary': '#00295B',
    'primaryDark': '#6d1201',
    'primaryMedium': '#851301',
    'primaryLight': '#62d7d7',

    'primaryAlternative':'#F2FBF4',
    'secondary': '#202939',
    'secondaryDark': '#000000',
    'secondaryLight': '#C1D2DB',
    'success': '#15d1b4',
    'danger': '#ee1d3a',
    'dangerDark': 'rgb(169,37,71)',
    'dangerLight': 'rgba(238,117,118,0.67)',

    'info': '#17a2b8',
    'warning': '#ffc60a',
    'default': '#000000',
    'white': '#fff',
    'light': '#fff',
    'dark': '#000000'
};

const table = {
    rowMinHeight: '45px',
    headerMinHeight: '40px',
    borderWidth: '1px',
    borderRadius: '5px',
    stripedColor: palette.primaryAlternative,
    borderColor: '#C1D2DB',
    overColor: '#c1d2db69',
};

const colors = {...palette }; // hack for some libraries

const page = {
    background: '#F6F7FB',
    color: palette.default,
    font: '\'Roboto\', sans-serif',
    fontsize: '0.9rem',
    fontWeight: 300,
    linkOver: palette.secondary,
    linkColor: palette.primary
};

const spacing = {
    '2x1': '0.65rem',
    '9': '2.25rem',
};
const minHeight = {
    50: '50px',
};
const boxShadow = {
    navbar: '0 1px 0 #C1D2DB'
};


const minWidth = {
    112: '112px',
    200: '200px',
    220: '220px',
    250: '250px',
};

export {
    palette,
    colors,
    page,
    minWidth,
    boxShadow,
    minHeight,
    spacing,
    table
};
